export const tableStateToParamsAdapter = (sortArray) => {
  if (!sortArray || !sortArray.length) {
    return {
      sortBy: {},
      sortOrder: []
    }
  }

  const sortBy = {}
  const sortOrder = []

  sortArray.forEach(({ id, desc }) => {
    sortBy[id] = desc ? 'DESC' : 'ASC'
    sortOrder.push(id)
  })

  return {
    sortBy,
    sortOrder
  }
}

export const paramsToTableStateAdapter = ({ sortBy, sortOrder }) => {
  if (!sortBy || !sortOrder || !sortOrder.length) {
    return []
  }

  return sortOrder.map(id => ({
    id,
    desc: sortBy[id] === 'DESC'
  }))
}
